import personalAccount from "@/plugins/api/factories/PersonalAccount";

export const state = {
  response: null,
  personalAccountData: null,
  ls: null,
  lastPay: null,
};

export const mutations = {
  SET_RESPONSE(state, response) {
    state.response = response;
  },
  SET_LS(state, ls) {
    state.ls = ls;
  },
  SET_LAST_PAY(state, lastPay) {
    state.lastPay = lastPay;
  },
  GET_PERSONAL_ACCOUNT_DATA(state, personalAccountData) {
    state.personalAccountData = personalAccountData;
  },
};

export const actions = {
  async setPersonalAccountData({ state, commit }) {
    return await personalAccount.setPrykarpattyaEnergoDataForPersonalAccount({ls: state.ls, lastPay: state.lastPay}, (response) => {
        commit("SET_RESPONSE", response);
    });
  },
  async getPersonalAccountData({ commit }) {
    return personalAccount.getPrykarpattyaEnergoDataForPersonalAccount((response) => {
      commit("SET_RESPONSE", response);
    });
  },
};
